import requestAction from '../../utils/requestAction'

export const fetchBouncedReceipt = (bouncedReceiptId: string, clientId?: string, sucursal?: string, numero?: string, params?: string) => {
  if (!params)
    params = '&limit=1000'
  const paramsId = bouncedReceiptId ? `?bouncedReceiptId=${bouncedReceiptId}` : sucursal ? `?sucursal=${sucursal}&numero=${numero}` : ''
  
  return requestAction('BOUNCED_RECEIPT_DETAIL', params)(`bouncedReceipts/detail${paramsId}${clientId ? '&clientId='+clientId: ''}`, 'GET')
}
